import type { IconProps } from './types';

const ThumbsDownIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 16, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M2.625 1.6875V12.9375M17.625 2.625L21.9272 14.8125H12.9375V18C12.9375 19.8639 11.4264 21.375 9.5625 21.375H8.71875L6.375 12.9375V2.625H17.625Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export { ThumbsDownIcon };
